<div class="stepper-header__header mb-1 text-center text-xl font-medium pt-2">
  {{ header }}
</div>
